import React, { FC, memo, SyntheticEvent } from 'react';
import { FnLoader } from '../FnLoader';
import { FnButtonSizes, FnButtonTypes, FnButtonVariants, FnButtonWidth } from './constants';
import { BUTTONS, SpanEndIcon, SpanStartIcon } from './styles';

interface Props {
  variant?: FnButtonVariants;
  width?: FnButtonWidth;
  viewType?: FnButtonTypes;
  text?: string;
  size?: FnButtonSizes;
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
  type?: 'button' | 'submit' | 'reset';
  disabled?: boolean;
  loading?: boolean;
  className?: string;
  onClick?: (event: SyntheticEvent) => void;
}

const FnButton: FC<Props> = ({
  viewType = FnButtonTypes.Default,
  variant = FnButtonVariants.Primary,
  size = FnButtonSizes.Medium,
  startIcon = null,
  endIcon = null,
  type = 'button',
  loading = false,
  disabled = false,
  text = '',
  width = FnButtonWidth.Auto,
  ...props
}) => {
  const TypedButton = BUTTONS[viewType];

  return (
    <TypedButton type={type} variant={variant} size={size} disabled={disabled || loading} width={width} {...props}>
      {startIcon && <SpanStartIcon>{startIcon}</SpanStartIcon>}
      {text}
      {endIcon && <SpanEndIcon>{endIcon}</SpanEndIcon>}
      {loading && <FnLoader />}
    </TypedButton>
  );
};

export default memo(FnButton);
